export type Pictures = { avif: string; pictureUrl: string };

export enum League {
  Global = 'global',
  LaLiga = 'laliga',
  PremierLeague = 'premier-league',
  Ligue1 = 'ligue-1',
  Bundesliga = 'bundesliga',
  NBA = 'nba',
  MLB = 'mlb',
}
